import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import SystemDashboard from './pages/SystemDashboard';
import S3ImageManager from './pages/S3ImageManager';
import ListView from './components/ListView';
import RecordForm from './components/RecordForm';
import theme from './theme';
import Chat from './components/chat/Chat';
import { Box, Toolbar } from '@mui/material';

// Initialize QueryClient
const queryClient = new QueryClient();

const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              
              {/* Protected routes */}
              <Route
                path="/*"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Routes>
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/system" element={<SystemDashboard />} />
                        <Route path="/s3-images" element={<S3ImageManager />} />
                        <Route path="/:tableName" element={<ListView />} />
                        <Route path="/:tableName/new" element={<RecordForm />} />
                        <Route path="/:tableName/:id" element={<RecordForm />} />
                        <Route path="*" element={<Navigate to="/dashboard" replace />} />
                      </Routes>
                      <Chat />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default App;
